import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle4 from "../../randing/RandingStyle4";

function Randing044({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/044/24123001.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/044/24123002.jpg`}
      benefitInfoPosition="top"
      formFieldColor="white"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/ApplyBenefitButton2.png`}
      companyName="광교365리움치과병원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/gwanggyo.jpg`}
    />
  );
}

export default Randing044;
